import React, { useState } from 'react';
import { connect } from 'react-redux';
import StepItem from './StepItem';
import Modal from './Modal';

function ConfigServerHost({ steps, clusterId }) {
  const [visible, setVisible] = useState(false);
  const [currentStepIndex, setCurrentStepIndex] = useState();

  const handleClose = () => {
    setVisible(false);
    setCurrentStepIndex(null);
  };

  const openHostSelect = (index) => {
    setVisible(true);
    setCurrentStepIndex(index);
  };

  return (
    <>
      {steps.map((step, index) => (
        <StepItem key={index} currentStep={step} openHostSelect={() => openHostSelect(index)} />
      ))}
      <Modal
        visible={visible}
        steps={steps}
        currentIndex={currentStepIndex}
        clusterId={clusterId}
        handleClose={handleClose}
        goIndex={setCurrentStepIndex}
      />
    </>
  );
}

export default connect((state) => ({
  clusterId: state.execFlow.currentCluster?.id,
}))(ConfigServerHost);
